import Api from './baseApi';

export default {
  async create(data) {
    return await Api.put('/ums/v1/role', data);
  },
  async update(id, data) {
    return await Api.post('/ums/v1/role/' + id, data);
  },
  async delete(id) {
    return await Api.delete('/ums/v1/role/' + id);
  },
  async fetch() {
    return await Api.get('/ums/v1/role');
  },
  async updateClaims(name, data) {
    return await Api.post('/ums/v1/role/update-claims/' + name, data);
  }
}
